const main = () => {
    const estateTypeCheckboxes = document.querySelectorAll('input[name="estate_type[]"]');
    const priceItems = document.querySelectorAll('.pg-price__item');
    const areaItems = document.querySelectorAll('.pg-area__item');

    const toggleItems = () => {
        const checkedTypes = Array.from(estateTypeCheckboxes)
            .filter(checkbox => checkbox.checked)
            .map(checkbox => checkbox.value);

        priceItems.forEach(item => {
            const type = item.dataset.estateType;
            item.style.display = checkedTypes.includes(type) ? '' : 'none';
        });

        areaItems.forEach(item => {
            const type = item.dataset.estateType;
            item.style.display = checkedTypes.includes(type) ? '' : 'none';
        });
    };

    toggleItems();

    estateTypeCheckboxes.forEach(checkbox => {
        checkbox.addEventListener('change', toggleItems);
    });
};

export default main;
